export const FEEDBACK_ATTACHMENT_BUCKET = 'feedback-ticket-attachments';
export const FEEDBACK_ATTACHMENT_MAX_BYTES = 5 * 1024 * 1024;
export const FEEDBACK_ATTACHMENT_MAX_COUNT = 5;
export const FEEDBACK_ATTACHMENT_ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'application/pdf',
] as const;

export type FeedbackAttachmentMimeType = (typeof FEEDBACK_ATTACHMENT_ALLOWED_MIME_TYPES)[number];

export type FeedbackAttachment = {
  id: string;
  ticket_id: string;
  thread_message_id: string | null;
  author: 'commerce' | 'staff';
  storage_path: string;
  original_filename: string;
  mime_type: FeedbackAttachmentMimeType;
  size_bytes: number;
  created_at: string;
  signed_url?: string | null;
};

export type FeedbackAttachmentDraft = {
  uri: string;
  name: string;
  mimeType: FeedbackAttachmentMimeType;
  size: number;
};

export function isFeedbackAttachmentMimeType(value: string | null | undefined): value is FeedbackAttachmentMimeType {
  return Boolean(value && FEEDBACK_ATTACHMENT_ALLOWED_MIME_TYPES.includes(value as FeedbackAttachmentMimeType));
}

export function validateFeedbackAttachmentDrafts(
  drafts: FeedbackAttachmentDraft[],
): string | null {
  if (drafts.length > FEEDBACK_ATTACHMENT_MAX_COUNT) {
    return `Podés adjuntar hasta ${FEEDBACK_ATTACHMENT_MAX_COUNT} archivos.`;
  }
  const total = drafts.reduce((sum, draft) => sum + draft.size, 0);
  if (drafts.some((draft) => draft.size <= 0 || draft.size > FEEDBACK_ATTACHMENT_MAX_BYTES)) {
    return 'Cada archivo puede pesar hasta 5 MB.';
  }
  if (total > FEEDBACK_ATTACHMENT_MAX_BYTES * FEEDBACK_ATTACHMENT_MAX_COUNT) {
    return 'El total de los archivos no puede superar 25 MB.';
  }
  if (drafts.some((draft) => !isFeedbackAttachmentMimeType(draft.mimeType))) {
    return 'Solo podés adjuntar imágenes o PDF.';
  }
  return null;
}

export function formatFeedbackAttachmentSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
